import { gql } from '@apollo/client';

export const GET_LEAD_SIMULATIONS_QUERY = gql`
  query GetLeadSimulations($leadId: ID!) {
    leadSimulations(leadId: $leadId) {
      leadInfo {
        name
        leadId
      }
      proposalsIndexedMetadata {
        favoriteProposalMetadata {
          simulationId
          description
          seller {
            id
            name
            pictureUrl
          }
          createdAt
          economyPercentage
          totalConsumationSummationInMwh
        }
      }
    }
  }
`;
